'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "currentColor",
    d: "M23.627 10.178 19.014 5.95l-.007-3.56a1.175 1.175 0 0 0-1.18-1.107l-.796-.01a1.136 1.136 0 0 0-1.169 1.139l-.007.642L13.064.495l-.178-.163a1.246 1.246 0 0 0-.44-.257l-.02-.006a1.335 1.335 0 0 0-.2-.05C12.2.014 12.172.013 12.144.01a.97.97 0 0 0-.286 0c-.028.002-.056.003-.084.008a1.34 1.34 0 0 0-.2.05c-.006.003-.013.004-.02.006a1.246 1.246 0 0 0-.439.257l-.178.163L.373 10.178A1.136 1.136 0 0 0 .32 11.81l.27.28a1.175 1.175 0 0 0 1.612.124l.803-.719V22.02a1.167 1.167 0 0 0 1.168 1.167h15.654a1.168 1.168 0 0 0 1.168-1.167V11.495l.803.719c.485.394 1.193.339 1.612-.124l.27-.28a1.136 1.136 0 0 0-.053-1.632Zm-11.979 10.26a1.457 1.457 0 1 1 1.455-1.456 1.464 1.464 0 0 1-1.455 1.455Zm1.385-5.56c-.426.622-.286 1.491-1.458 1.491a1.13 1.13 0 0 1-1.136-1.189c0-2.114 3.11-2.597 3.11-4.337 0-.96-.642-1.529-1.708-1.529-2.274 0-1.385 2.347-3.107 2.347a1.062 1.062 0 0 1-1.154-1.085c0-1.741 1.99-3.286 4.155-3.286 2.277 0 4.514 1.048 4.514 3.553 0 2.31-2.647 3.199-3.216 4.034Z"
  }));
});
var StatusDontknow = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.StatusDontknow = StatusDontknow;